import React, { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import { routes } from "src/App.routes";
import { Button } from "src/components/atoms/button/button";
import { Container } from "src/components/atoms/container/container";
import { Text } from "src/components/atoms/text/text";
import { Textarea } from "src/components/atoms/textarea/textarea";
import { LoadingScreen } from "src/components/molecules/loadingScreen/loadingScreen";
import { OfflineLock } from "src/components/molecules/offlineLock/offlineLock";
import { PageHeader } from "src/components/molecules/pageHeader/pageHeader";
import { AppContext } from "src/contexts/appContext";
import { useAuthContext } from "src/contexts/authContext";
import { Page } from "src/layouts/page";
import { IError } from "src/types/IError";

export const UpgradeAdvice = () => {
  const [comm, setComm] = useState<string>("");
  const [error, setError] = useState<IError>();
  const [loading, setLoading] = useState<boolean>(false);
  const history = useHistory();
  const { api, toast, isOnline, getHomeItemTitle } = useContext(AppContext);
  const { user: {email} = {} } = useAuthContext()
  const onSubmit = (): void => {
    setError(undefined);
    if (!comm || comm === "") {
      setError({
        field: "comm",
        message: "Remplissez ce champs afin de nous faire part de votre avis",
      });
    } else {
      setLoading(true);
      api.user
        .sendSuggestion({ message: comm, email: email || '' })
        .then(() => {
          setLoading(false);
          history.push(routes.upgradeAdviceConfirmation);
        })
        .catch(() => {
          setLoading(false);
          toast.createUnknkowError();
        });
    }
  };
  return (
    <Page pageClass="upgradeAdvice">
      {!isOnline && <OfflineLock />}
      <PageHeader back={routes.home} title={getHomeItemTitle("upgradeAdvice")} />
      <Container>
        <Text type="h2">Faites-nous part de vos commentaires et suggestions pour améliorer l'application.</Text>
        <Textarea
          name="Commentaire"
          value={comm}
          setValue={setComm}
          error={error?.field === "comm"}
        />
        {error?.field === "comm" && (
          <Text type="p3" color="orange">
            {error.message}u
          </Text>
        )}
        <Button large onClick={onSubmit}>
          Envoyer
        </Button>
        <LoadingScreen show={loading} message="Envoi en cours" backdrop />
      </Container>
    </Page>
  );
};
